var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.tableType == 1,
          expression: "tableType == 1"
        }
      ]
    },
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.showdata.slice(
              (_vm.currentPage - 1) * _vm.pageSize,
              _vm.currentPage * _vm.pageSize
            ),
            "cell-style": _vm.setStyle1,
            "max-height": _vm.tableHeight
          },
          on: {
            "filter-change": _vm.filterChange,
            "sort-change": _vm.handleSortChange
          }
        },
        [
          _c("el-table-column", {
            key: "1",
            attrs: {
              label: "人员",
              prop: "fuUser",
              "column-key": "fuUser",
              filters: _vm.userAll,
              "filter-method": _vm.filterHandler1
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", [_vm._v(_vm._s("主要人员:" + row.fuUser))]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s("辅助人员:" + row.user))])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            { key: "2", attrs: { label: "楼盘数据" } },
            [
              _c("el-table-column", {
                key: "3",
                attrs: {
                  label: "城区",
                  prop: "district",
                  "column-key": "district",
                  filters: _vm.districts,
                  "filter-method": _vm.filterHandler1
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "4",
                attrs: {
                  label: _vm.computetotal,
                  "column-key": "real_estate_name",
                  prop: "real_estate_name"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "24",
                attrs: {
                  label: "楼盘月浏览量",
                  prop: "person_page",
                  "column-key": "person_page",
                  sortable: "custom"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              (row.area_rank && row.area_rank.thirtyHits) || 0
                            )
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "5",
                attrs: {
                  label: "销售状态",
                  filters: [
                    { text: "在售", value: "在售" },
                    { text: "待首开", value: "待首开" }
                  ],
                  "filter-method": _vm.filterHandler1,
                  prop: "real_status",
                  "column-key": "real_status"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            { key: "6", attrs: { label: "综合数据" } },
            [
              _c("el-table-column", {
                key: "7",
                attrs: {
                  label: "综合完整度",
                  filters: [
                    { text: "达标", value: "达标" },
                    { text: "不达标", value: "不达标" }
                  ],
                  "filter-method": _vm.filterHandler111,
                  prop: "all_tagecg",
                  "column-key": "all_tagecg",
                  sortable: "custom"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            { key: "9", attrs: { label: "户型相关" } },
            [
              _c("el-table-column", {
                key: "10",
                attrs: {
                  label: "户型尺寸",
                  filters: [
                    { text: "有", value: "有" },
                    { text: "无", value: "无" }
                  ],
                  prop: "hx",
                  "filter-method": _vm.filterHandler11,
                  "column-key": "hx"
                }
              }),
              _vm._v(" "),
              _vm.city == "杭州"
                ? _c("el-table-column", {
                    key: "12",
                    attrs: {
                      label: "精装配置",
                      filters: [
                        { text: "有", value: "有" },
                        { text: "无", value: "无" }
                      ],
                      "filter-method": _vm.filterHandler11,
                      prop: "tabel",
                      "column-key": "tabel"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            { key: "13", attrs: { label: "楼盘动态" } },
            [
              _c("el-table-column", {
                key: "14",
                attrs: {
                  label: "预计开盘",
                  prop: "expect",
                  filters: _vm.expectFilters,
                  "filter-method": _vm.expectFilterHandler,
                  "column-key": "expect"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s((row.expect && row.expect.date) || row.xs)
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "16",
                attrs: {
                  label: "销售动态",
                  filters: [
                    { text: "有", value: "有" },
                    { text: "无", value: "无" }
                  ],
                  "filter-method": _vm.filterHandler11,
                  prop: "dynamic",
                  "column-key": "dynamic"
                }
              }),
              _vm._v(" "),
              _vm.city == "杭州"
                ? _c("el-table-column", {
                    key: "17",
                    attrs: {
                      label: "优惠动态",
                      prop: "youhui",
                      filters: [
                        { text: "有", value: "有" },
                        { text: "无", value: "无" }
                      ],
                      "filter-method": _vm.filterHandler11,
                      "column-key": "youhui"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            { key: "19", attrs: { label: "常规" } },
            [
              _c("el-table-column", {
                key: "20",
                attrs: {
                  label: "详细完成度",
                  prop: "details_tage",
                  filters: [
                    { text: "达标", value: "达标" },
                    { text: "不达标", value: "不达标" }
                  ],
                  "filter-method": _vm.filterHandler111,
                  "column-key": "details_tage",
                  sortable: "custom"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "21",
                attrs: {
                  label: "图片",
                  sortable: "custom",
                  prop: "estate",
                  filters: [
                    { text: "已完成", value: "已完成" },
                    { text: "未完成", value: "未完成" }
                  ],
                  "column-key": "estate"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "22",
                attrs: {
                  label: "视频",
                  sortable: "custom",
                  prop: "video",
                  "column-key": "video",
                  filters: [
                    { text: "已完成", value: "已完成" },
                    { text: "未完成", value: "未完成" }
                  ]
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("el-table-column", { key: "23", attrs: { label: "积分" } })
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.currentPage,
          "page-size": _vm.pageSize,
          layout: "total, prev, pager, next, jumper",
          total: _vm.showdata.length
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f255aa7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f255aa7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sjandyuny.vue
// module id = null
// module chunks = 